export const INSURERS = [
    {
        key: 'lifeline',
        label: 'BUPA Lifeline',
        standardLabel: 'LIFELINE',
        implemented: true,
        plans: [
            { id: 'lifeline_essential', label: 'Essential' },
            { id: 'lifeline_classic', label: 'Classic' },
            { id: 'lifeline_gold', label: 'Gold' },
        ],
    },
    {
        key: 'bwho',
        label: 'BUPA WHO',
        standardLabel: 'WORLDWIDE HEALTH OPTIONS',
        implemented: true,
        plans: [
            { id: 'bwho_wmi', label: 'WMI' },
            { id: 'bwho_wmp', label: 'WMI + WMP' },
            { id: 'bwho_wme', label: 'WMI + WMP + WME' },
            { id: 'bwho_ww', label: 'WMI + WMP + WME + WW' },
        ],
    },
    {
        key: 'company',
        label: 'BUPA Company',
        standardLabel: 'BUPA COMPANY',
        implemented: true,
        plans: [
            { id: 'company_essential', label: 'Essential' },
            { id: 'company_classic', label: 'Classic' },
            { id: 'company_classic_with_dental', label: 'Classic with Dental' },
            { id: 'company_gold', label: 'Gold' },
            { id: 'company_gold_with_dental', label: 'Gold with Dental' },
            { id: 'company_gold_superior', label: 'Gold Superior' },
            { id: 'company_gold_superior_with_dental', label: 'Gold Superior with Dental' },
        ],
    },
    {
        key: 'oil_gas',
        label: 'BUPA Oil & Gas',
        standardLabel: 'BUPA OIL & GAS',
        implemented: true,
        plans: [
            { id: 'oil_gas_essential', label: 'Essential' },
            { id: 'oil_gas_classic', label: 'Classic' },
            { id: 'oil_gas_gold', label: 'Gold' },
        ],
    },
    {
        key: 'first_choice',
        label: 'BUPA First Choice',
        plans: [
            { id: 'first_choice_module_1', label: 'Module 1' },
            { id: 'first_choice_module_1_2', label: 'Module 1 + Module 2' },
            { id: 'first_choice_module_1_2_3', label: 'Module 1 + Module 2 + Module 3' },
            { id: 'first_choice_module_1_2_3_5', label: 'Module 1 + Module 2 + Module 3 + Module 5' },
            { id: 'first_choice_module_1_2_3_5_6', label: 'Module 1 + Module 2 + Module 3 + Module 5 + Module 6' },
        ],
    },
    {
        key: 'ihhp',
        label: 'BUPA IHHP KSK',
        standardLabel: 'INTERNATIONAL HEALTH AND HOSPITAL PLAN',
        implemented: true,
        plans: [
            { id: 'ihhp_hospital_plan', label: 'Hospital Plan' },
            { id: 'ihhp_non_hospitalisation_benefits', label: 'Module 1' },
            { id: 'ihhp_medicine_appliances', label: 'Module 2' },
            { id: 'ihhp_medical_evacuation_repatriation', label: 'Module 3' },
            { id: 'ihhp_dental_optical_a', label: 'Module 4A' },
            { id: 'ihhp_dental_optical_b', label: 'Module 4B' },
        ],
    },
    {
        key: 'bhp_indonesia',
        label: 'BUPA BHP Indonesia',
        standardLabel: 'BHP INDONESIA',
        implemented: true,
        plans: [
            { id: 'bhp_indonesia_select', label: 'Select' },
            { id: 'bhp_indonesia_premier', label: 'Premier' },
            { id: 'bhp_indonesia_elite', label: 'Elite' },
            { id: 'bhp_indonesia_ultimate', label: 'Ultimate' },
        ],
    },
    {
        key: 'vumi',
        label: 'VUMI',
        standardLabel: 'VUMI GLOBAL FLEX VIP',
        implemented: true,
        plans: [
            { id: 'vumi_basic', label: 'Basic' },
            { id: 'vumi_standard', label: 'Standard' },
            { id: 'vumi_superior', label: 'Superior' },
            { id: 'vumi_ultra', label: 'Ultra' },
            { id: 'vumi_total', label: 'Total' },
        ],
    },
    {
        key: 'optimum_global',
        label: 'AXA - Optimum Global',
        standardLabel: 'OPTIMUM GLOBAL',    
        implemented: true,
        plans: [
            { id: 'optimum_global_emerald', label: 'Emerald' },
            { id: 'optimum_global_sapphire', label: 'Sapphire' },
            { id: 'optimum_global_ruby', label: 'Ruby' },
            { id: 'optimum_global_jade', label: 'Jade' },
            { id: 'optimum_global_diamond', label: 'Diamond' },
        ],
    },
    {
        key: 'morgan_price',
        label: 'Morgan Price International',
        standardLabel: 'MORGAN PRICE - FLEXIBLE CHOICES ASIA',
        implemented: true,
        plans: [
            { id: 'morgan_price_core_ip', label: 'Core' },
            { id: 'morgan_price_core_op1', label: 'Core + OP1' },
            { id: 'morgan_price_core_op2', label: 'Core + OP2' },
        ],
    },
    {
        key: 'pro_medico',
        label: 'Liberty proMedico',
        standardLabel: 'LIBERTY PROMEDICO',
        implemented: true,
        plans: [
            { id: 'pro_medico_premier', label: 'Premier' },
            { id: 'pro_medico_premier_plus', label: 'Premier Plus' },
            { id: 'pro_medico_prime', label: 'Prime' },
            { id: 'pro_medico_prestige', label: 'Prestige' },
            { id: 'pro_medico_prestige_plus', label: 'Prestige Plus' },
        ],
    },
    {
        key: 'cigna_care_connect',
        label: 'Cigna Care Connect',
        standardLabel: 'CIGNA CARE CONNECT',
        implemented: true,
        plans: [
            { id: 'cigna_care_connect_prestige', label: 'Prestige' },
            { id: 'cigna_care_connect_elite', label: 'Elite' },
            { id: 'cigna_care_connect_executive', label: 'Executive' },
        ],
    },
    {
        key: 'cigna_global_health_option',
        label: 'Cigna Global Health Option',
        standardLabel: 'CIGNA GLOBAL HEALTH OPTION',
        implemented: true,
        plans: [
            { id: 'cigna_global_health_option_silver', label: 'Silver' },
            { id: 'cigna_global_health_option_platinum', label: 'Platinum' },
            { id: 'cigna_global_health_option_gold', label: 'Gold' },
        ],
    },
    {
        key: 'hsbc_smart_care_optimum_enhanced',
        label: 'HSBC SmartCare Optimum Enhanced',
        standardLabel: 'HSBC SMARTCARE OPTIMUM ENHANCED',
        implemented: true,
        plans: [
            { id: 'hsbc_smart_care_optimum_enhanced_bronze', label: 'Bronze' },
            { id: 'hsbc_smart_care_optimum_enhanced_silver', label: 'Silver' },
            { id: 'hsbc_smart_care_optimum_enhanced_gold', label: 'Gold' },
            { id: 'hsbc_smart_care_optimum_enhanced_platinum', label: 'Platinum' },
        ],
    },
    {
        key: 'pacific_cross_primary_care_plan',
        label: 'Pacific Cross PrimaryCare Plan',
        standardLabel: 'PACIFIC CROSS PRIMARYCARE PLAN',
        implemented: true,
        plans: [
            { id: 'pacific_cross_primary_care_plan_core', label: 'Core' },
            { id: 'pacific_cross_primary_care_plan_core_with_op', label: 'Core_wOP' },
            { id: 'pacific_cross_primary_care_plan_pulse', label: 'Pulse' },
            { id: 'pacific_cross_primary_care_plan_complete', label: 'Complete' },
        ],
    },
    {
        key: 'pacific_cross_select',
        label: 'Pacific Cross Select',
        standardLabel: 'PACIFIC CROSS SELECT',
        implemented: true,
        plans: [
            { id: 'pacific_cross_select_plus', label: 'Select Plus' },
            { id: 'pacific_cross_select_standard', label: 'Select Standard' },
        ],
    },
    {
        key: 'pacific_cross_blue_royale',
        label: 'Pacific Cross Blue Royale',
        standardLabel: 'PACIFIC CROSS BLUE ROYALE',
        implemented: true,
        plans: [
            { id: 'pacific_cross_blue_royale_plan_a', label: 'Plan A' },
            { id: 'pacific_cross_blue_royale_plan_b', label: 'Plan B' },
            { id: 'pacific_cross_blue_royale_plan_c', label: 'Plan C' },
        ],
    },
    {
        key: 'my_health_indonesia',
        label: 'April (MyHealth) Indonesia',
        standardLabel: 'APRIL MYHEALTH INDONESIA',
        implemented: true,
        plans: [
            { id: 'my_health_indonesia_core', label: 'Core' },
            { id: 'my_health_indonesia_essential', label: 'Essential' },
            { id: 'my_health_indonesia_extensive', label: 'Extensive' },
            { id: 'my_health_indonesia_elite', label: 'Elite' },
        ],
    },
    {
        key: 'my_health_singapore',
        label: 'April (MyHealth) Singapore',
        standardLabel: 'APRIL MYHEALTH SINGAPORE',
        implemented: true,
        plans: [
            { id: 'my_health_singapore_essential', label: 'Essential' },
            { id: 'my_health_singapore_extensive', label: 'Extensive' },
            { id: 'my_health_singapore_elite', label: 'Elite' },
        ],
    },
    {
        key: 'my_health_vietnam',
        label: 'April (MyHealth) Vietnam',
        standardLabel: 'APRIL MYHEALTH VIETNAM',
        plans: [
            { id: 'my_health_vietnam_essential', label: 'Essential' },
            { id: 'my_health_vietnam_extensive', label: 'Extensive' },
            { id: 'my_health_vietnam_elite', label: 'Elite' },
        ],
    },
    {
        key: 'my_health_philippines',
        label: 'April (MyHealth) Philippines',
        standardLabel: 'APRIL MYHEALTH PHILIPPINES',
        implemented: true,
        plans: [
            { id: 'my_health_philippines_essential', label: 'Essential' },
            { id: 'my_health_philippines_extensive', label: 'Extensive' },
            { id: 'my_health_philippines_elite', label: 'Elite' },
        ],
    },
];
